import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Stack } from '@mui/material'
import { useAtomValue, useSetAtom } from 'jotai'
import { condParamAtom, searchTriggerAtom } from 'store/commonAtoms'
import { H3 } from 'components/styledFonts'
import { RadioGroupBase } from 'components/Inputs'
import SearchButton from 'components/SearchButton'


const list = [
    { label : '企業検索', value : '/search/company/1' },
    { label : 'プレスリリース', value : '/search/pressrelease/1' },
    { label : 'ニュースレター', value : '/search/newsletter/1' },
    { label : '企業探訪', value : '/search/inquiry/1' },
]

const TargetSelector = () => {
    const [value, setValue] = useState(list[0].value)
    const setTrigger = useSetAtom(searchTriggerAtom)
    const navi = useNavigate()
    const { pathname } = useLocation()
    const params = useAtomValue(condParamAtom)

    useEffect(() => {
        const v = list.find(l => l.value === pathname)?.value
        if (v) setValue(v)
    }, [pathname])

    const handleChange = e => {
        setTrigger(true)
        navi(`${e.target.value}${params}`)
    }

    return (
        <Stack
            direction='row'
            justifyContent='space-between'
            pb={1}
        >
            <Stack
                gap={0.5}
            >
                <H3>検索対象</H3>
                <RadioGroupBase
                    value={value}
                    list={list}
                    onChange={handleChange}
                    sx={{ px : 1 }}
                />
            </Stack>
            <SearchButton />
        </Stack>
    )
}

export default TargetSelector
